import {Component, OnInit} from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import {AuthService} from '../services/auth.service';
import {UserModel} from '../models/User';
import {Subscription} from 'rxjs/internal/Subscription';
import {Router} from '@angular/router';

@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html'
})
export class AppProfileSidebarComponent implements OnInit{
    user: UserModel
    private userSubscription!: Subscription
    constructor(public layoutService: LayoutService, private auth: AuthService, private route: Router) { }

    ngOnInit(): void {
        this.userSubscription = this.auth.user$.subscribe(user => {
            this.user = user;
        });
    }

    goToSettings(){
        this.route.navigate(['/account', 'settings'])
    }

    goToProfile(){
        this.route.navigate(['/account'])

    }
    goToBilling(){
        this.route.navigate(['/account', 'billing'])

    }
    get visible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.profileSidebarVisible = _val;
    }

}
